/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScriptExecutionTargetStateEnum } from './scriptExecutionTargetStateEnum';


export interface ScriptExecutionTargetDto { 
    /**
     * Sequence-generated identifier for this execution target
     */
    id: number;
    /**
     * UUID of the parent execution
     */
    execution_id: string;
    state: ScriptExecutionTargetStateEnum;
    /**
     * Target specification (cloud/org/region/component details)
     */
    execution_target?: { [key: string]: any; };
    /**
     * Response from the execution engine for this target
     */
    execution_response?: { [key: string]: any; };
    /**
     * Collated script result including status, stdout, stderr, completedAt, and optional S3 keys
     */
    execution_output?: { [key: string]: any; };
    created_ts?: Date;
    created_by?: string;
    updated_ts?: Date;
    updated_by?: string;
}
export namespace ScriptExecutionTargetDto {
}


